import http from "./httpService";

const endPoint = "/api/v1/CostCenter";

export function getCostCenter(request) {
    return http.post(`${endPoint}`, request);
}

export default {getCostCenter};


// WEBPACK FOOTER //
// ./src/services/costCenterService.js